module.exports = __webpack_public_path__ + "img/cropwise.3c2cf185.png";